// extracted by mini-css-extract-plugin
module.exports = {"brand":"appBrand_brand__pdxJt","name":"appBrand_name__C_2FS","logo":"appBrand_logo__0LwVg"};